export default `/* Ids Alert Component */
:host,
.ids-alert {
  color: var(--ids-alert-color-default);
  display: inline-flex;
  align-items: center;
}
:host:has(.label-text:not([hidden])),
.ids-alert:has(.label-text:not([hidden])) {
  gap: var(--ids-alert-gap);
}
:host.success,
:host [color=success],
:host [icon=success],
.ids-alert.success,
.ids-alert [color=success],
.ids-alert [icon=success] {
  color: var(--ids-alert-color-success-default);
}
:host.success.disabled,
:host [color=success].disabled,
:host [icon=success].disabled,
.ids-alert.success.disabled,
.ids-alert [color=success].disabled,
.ids-alert [icon=success].disabled {
  color: var(--ids-alert-color-success-disabled);
}
:host.alert,
:host [color=alert],
:host [icon=alert], :host.warning,
:host [color=warning],
:host [icon=warning],
.ids-alert.alert,
.ids-alert [color=alert],
.ids-alert [icon=alert],
.ids-alert.warning,
.ids-alert [color=warning],
.ids-alert [icon=warning] {
  color: var(--ids-alert-color-warning-default);
}
:host.alert.disabled,
:host [color=alert].disabled,
:host [icon=alert].disabled, :host.warning.disabled,
:host [color=warning].disabled,
:host [icon=warning].disabled,
.ids-alert.alert.disabled,
.ids-alert [color=alert].disabled,
.ids-alert [icon=alert].disabled,
.ids-alert.warning.disabled,
.ids-alert [color=warning].disabled,
.ids-alert [icon=warning].disabled {
  color: var(--ids-alert-color-warning-disabled);
}
:host.caution,
:host [color=caution],
:host [icon=caution],
.ids-alert.caution,
.ids-alert [color=caution],
.ids-alert [icon=caution] {
  color: var(--ids-alert-color-caution-default);
}
:host.caution.disabled,
:host [color=caution].disabled,
:host [icon=caution].disabled,
.ids-alert.caution.disabled,
.ids-alert [color=caution].disabled,
.ids-alert [icon=caution].disabled {
  color: var(--ids-alert-color-caution-disabled);
}
:host.info,
:host [color=info],
:host [icon=info],
.ids-alert.info,
.ids-alert [color=info],
.ids-alert [icon=info] {
  color: var(--ids-alert-color-info-default);
}
:host.info.disabled,
:host [color=info].disabled,
:host [icon=info].disabled,
.ids-alert.info.disabled,
.ids-alert [color=info].disabled,
.ids-alert [icon=info].disabled {
  color: var(--ids-alert-color-info-disabled);
}
:host.error,
:host [color=error],
:host [icon=error],
.ids-alert.error,
.ids-alert [color=error],
.ids-alert [icon=error] {
  color: var(--ids-alert-color-error-default);
}
:host.error.disabled,
:host [color=error].disabled,
:host [icon=error].disabled,
.ids-alert.error.disabled,
.ids-alert [color=error].disabled,
.ids-alert [icon=error].disabled {
  color: var(--ids-alert-color-error-disabled);
}
:host.new,
:host [color=new],
:host [icon=new],
.ids-alert.new,
.ids-alert [color=new],
.ids-alert [icon=new] {
  color: var(--ids-alert-color-new-default);
}
:host.new.disabled,
:host [color=new].disabled,
:host [icon=new].disabled,
.ids-alert.new.disabled,
.ids-alert [color=new].disabled,
.ids-alert [icon=new].disabled {
  color: var(--ids-alert-color-new-disabled);
}
:host.in-progress,
:host [color=purple],
:host [icon=in-progress],
.ids-alert.in-progress,
.ids-alert [color=purple],
.ids-alert [icon=in-progress] {
  color: var(--ids-alert-color-progress-default);
}
:host.in-progress.disabled,
:host [color=purple].disabled,
:host [icon=in-progress].disabled,
.ids-alert.in-progress.disabled,
.ids-alert [color=purple].disabled,
.ids-alert [icon=in-progress].disabled {
  color: var(--ids-alert-color-progress-disabled);
}
:host .custom-disabled, :host .disabled,
.ids-alert .custom-disabled,
.ids-alert .disabled {
  opacity: var(--ids-opacity-disabled);
}
:host ids-icon.data-empty,
.ids-alert ids-icon.data-empty {
  min-inline-size: 18px;
  min-block-size: 18px;
  background-color: var(--ids-color-accent-neutral-weaker);
  border-radius: var(--ids-border-radius-md);
}
:host ids-icon.data-empty[size=large],
.ids-alert ids-icon.data-empty[size=large] {
  min-inline-size: 24px;
  min-block-size: 24px;
}
:host ids-icon.data-empty[size=small],
.ids-alert ids-icon.data-empty[size=small] {
  min-inline-size: 16px;
  min-block-size: 16px;
}
:host .label-text,
.ids-alert .label-text {
  font-size: var(--ids-alert-font-size);
  line-height: var(--ids-alert-line-height);
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */`;
